import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Maybe } from "graphql/jsutils/Maybe";

export interface Order {
  orderId: number | undefined;
  chatId: number | undefined;
  receiverId: Maybe<number> | undefined;
  minPrice: number | undefined;
  orderQuantity: number | undefined;
  currency: string;
  quoteIsValid: boolean;
  uploadFile: boolean;
  files: File[];
}

const initialState: Order = {
  orderId: undefined,
  chatId: undefined,
  receiverId: undefined,
  minPrice: undefined,
  orderQuantity: undefined,
  currency: "",
  quoteIsValid: false,
  uploadFile: false,
  files: [],
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderId(state, action: PayloadAction<number | undefined>) {
      state.orderId = action.payload;
    },
    setChatId(state, action: PayloadAction<number | undefined>) {
      state.chatId = action.payload;
    },
    setReceiverId(state, action: PayloadAction<Maybe<number> | undefined>) {
      state.receiverId = action.payload;
    },
    setMinPrice(state, action: PayloadAction<number | undefined>) {
      state.minPrice = action.payload;
    },
    setCurrency(state, action: PayloadAction<string>) {
      state.currency = action.payload;
    },
    setOrder(state, action: PayloadAction<Order>) {
      return { ...state, ...action.payload };
    },
    setUploadFile(state, action: PayloadAction<boolean>) {
      state.uploadFile = action.payload;
    },
    setFiles(state, action: PayloadAction<File[]>) {
      return { ...state, ...action.payload };
    },
    resetOrder() {
      return initialState;
    },
    setQuoteIsValid(state, action: PayloadAction<boolean>) {
      state.quoteIsValid = action.payload;
    },
    setOrderQuantity(state, action: PayloadAction<number | undefined>) {
      state.orderQuantity = action.payload;
    },
  },
});

export const {
  setOrderId,
  setChatId,
  setReceiverId,
  setMinPrice,
  setCurrency,
  setOrder,
  resetOrder,
  setQuoteIsValid,
  setUploadFile,
  setFiles,
  setOrderQuantity,
} = orderSlice.actions;

export default orderSlice.reducer;
